import React from 'react';

import BillingForm from 'components/billing-form/billing-form'

import { Elements, StripeProvider } from 'react-stripe-elements'

import { environmentIndex } from 'env'

const UpgradeAccount = props => {
    const keys = [
        'pk_test_cAKKfcpav5trEkMSrBXq3A8P00UM8VYpeR',
        'pk_live_LyD6BI6rDUiy9vW8eT0Y70H500iMTPgA44'
    ]

    let keyIndex = 1

    if(!environmentIndex){
        console.log('Warning: Using test Stripe keys')
        keyIndex = 0
    }

    return (
        <StripeProvider apiKey={keys[keyIndex]}>
            <Elements>
                <BillingForm {...props} />
            </Elements>
        </StripeProvider>
    );
};

export default UpgradeAccount


// WEBPACK FOOTER //
// ./src/components/auth/upgrade-account.jsx